import { render, staticRenderFns } from "./paper-result.vue?vue&type=template&id=3d7ff68e&scoped=true"
import script from "./paper-result.vue?vue&type=script&lang=ts"
export * from "./paper-result.vue?vue&type=script&lang=ts"
import style0 from "./paper-result.vue?vue&type=style&index=0&id=3d7ff68e&prod&lang=scss&scoped=true"
import style1 from "./paper-result.vue?vue&type=style&index=1&id=3d7ff68e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ff68e",
  null
  
)

export default component.exports